import React from "react"
import styled from "styled-components"
import Compressor from 'compressorjs'

import { FormNavigationContext } from "../../../Panes/Form"
import { media } from "../../../../components/mediaStyles"
import { postData } from "../../../../api"
import {
  compact,
  isUndefined,
  get,
  keyBy,
  groupBy,
  values,
  mapValues,
  pickBy,
  flatten,
  isNull,
} from "lodash"

import ProgressBar from "./ProgressBar"

const SectionContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`

const FileUploadRow = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  flex-direction: column;
  align-items: center;
  margin-bottom: 15px;
  > * {
    width: 100%;
  }

  ${media.tablet`
    flex-direction: row;
  `}
`

const FileUploadName = styled.div`
  flex: 1;
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  text-align: left;
  > *:first-child {
    margin-right: 10px;
  }
  ${media.tablet`

  `}
`

export default class FileUploadSection extends React.Component {
  state = {
    percentage: 0,
    files: [],
  }

  onChange = () => {
    this.props.onSubmit(this.props.question.identifier)
  }

  uploadFiles = async fileList => {
    if (compact(fileList).length == 0) {
      return [0, null]
    }
    const formData = new FormData()
    let fileSizeInBytes = 0
    fileList.forEach(({ file }) => {
       fileSizeInBytes += file.size
       formData.append("files[]", file)
      // removed file compression as it caused issues, absence has not been noticeable
    });

    const start = Date.now()
    const files = await postData(
      `${this.props.fileUrl}${window && window.location.search}`,
      {},
      {
        body: formData,
        headers: {},
      }
    )

    const finishedAfterSeconds = (Date.now() - start) / 1000
    return [fileSizeInBytes / finishedAfterSeconds, files]
  }

  uploadFilesIfExist = ([firstFile, ...otherFiles]) => {
    if (isUndefined(firstFile)) return Promise.resolve()

    return this.uploadFiles([firstFile])
      .then(([bytesPerSecond, uploadedFiles]) => {
        let uploadSize = otherFiles.reduce(
          (size, { file }) => size + file.size,
          0
        )
        this.setState({
          files: {
            ...get(this.state, "files", {}),
            ...keyBy(
              otherFiles.map(({ file }) => {
                return {
                  ...get(this.state, ["files", file.uid], {}),
                  seconds: uploadSize / bytesPerSecond + 2,
                  delay: 2,
                }
              }),
              "uid"
            ),
            [firstFile.file.uid]: {
              ...get(this.state, ["files", firstFile.file.uid], {}),
              ...(isUndefined(uploadedFiles)
                ? { status: "exception" }
                : {
                    fileId: get(uploadedFiles, [0, "fileId"]),
                  }),
              progress: 100,
            },
          },
        })
        return
      })
      .then(() => this.uploadFiles(otherFiles))
      .then(([_uploadSpeed, uploadedFiles]) => {
        this.setState(
          {
            files: {
              ...get(this.state, "files"),
              ...keyBy(
                otherFiles.map(({ file }, index) => {
                  return {
                    ...get(this.state, ["files", file.uid], {}),
                    ...(isUndefined(get(uploadedFiles, index))
                      ? { status: "exception" }
                      : {
                          fileId: get(uploadedFiles, [index, "fileId"]),
                        }),
                    progress: 100,
                  }
                }),
                "uid"
              ),
            },
          },
          () => {
            const groupedFiles = groupBy(values(this.state.files), "key")
            console.log("Grouped files", groupedFiles, this.state.files)
            const adjustedFileItems = mapValues(groupedFiles, value => {
              return value.map(({ file, fileId, name }) => ({
                fileId,
                name,
                type: get(file, "type"),
                size: get(file, "size"),
              }))
            })
            this.props.setFormFields(adjustedFileItems)
          }
        )
      })
      .catch(er => {
        console.error("Error when uploading", er)
      })
  }

  componentDidMount() {
    if (this.context.activeIdentifier !== this.props.question.identifier) return

    // Checking for any selected files in questions
    let files = pickBy(this.context.result, value => {
      if (Array.isArray(value))
        return value.reduce(
          (hasFile, currentItem) =>
            hasFile ||
            get(currentItem, "file") instanceof File ||
            get(currentItem, "fileId")
        )
      return false
    })
    // Create Array of files with keys and fileId
    files = flatten(
      values(
        mapValues(files, (files, key) => {
          // Store form identifier for each file
          if (Array.isArray(files)) {
            return files.map(({ file, fileId, ...other }) => ({
              file,
              key,
              fileId,
              ...other,
            }))
          }
          return { file: files, key }
        })
      )
    )

    this.fileMap = keyBy(files, "file.uid")
    let uploadedFiles = files.filter(({ fileId }) => fileId)
    let filesToUpload = files.filter(
      ({ fileId, file }) => isUndefined(fileId) && file
    )
    this.setState({
      files: keyBy(
        [...filesToUpload, ...uploadedFiles].map(
          ({ file, key, fileId, name, size }, index) => ({
            name: get(file, "name") || name,
            file: file,
            uid: get(file, "uid") || fileId,
            size: get(file, "size") || size,
            key,
            fileId,
            // First one should show a loading progress immediately
            ...(index == 0
              ? {
                  seconds: 10,
                }
              : {}),
            // Files that already have a fileId have already been updated
            ...(fileId
              ? {
                  progress: 100,
                }
              : {}),
          })
        ),
        "uid"
      ),
    })

    this.uploadFilesIfExist(filesToUpload).then(this.props.onFinish)
  }

  componentWillUnmount() {
    // What should happen wenn unmount during upload?
    this.fileMap = {}
  }

  render() {
    return (
      <SectionContainer>
        {this.props.getFieldDecorator &&
          this.props.getFieldDecorator(this.props.question.identifier, {
            initialValue: this.props.value,
            rules: [
              {
                required: this.props.question.required,
                message: "Der Upload ist noch nicht abgeschlossen",
              },
            ],
          })(<span />)}

        {this.state.files &&
          values(this.state.files).map((file, index) => {
            return (
              <FileUploadRow key={file.name + "-" + index}>
                <FileUploadName>
                  <span>{file.name} </span>
                  {file.size && (
                    <span>
                      ({Math.floor((file.size / 1024 / 1024) * 100) / 100} mb)
                    </span>
                  )}
                </FileUploadName>{" "}
                <div style={{ flex: 1 }}>
                  <ProgressBar
                    seconds={file.seconds}
                    delay={file.delay}
                    status={file.status}
                    {...(!isUndefined(file.progress) && !isNull(file.progress)
                      ? { percent: file.progress }
                      : {})}
                    size="small"
                  />
                </div>
              </FileUploadRow>
            )
          })}
      </SectionContainer>
    )
  }
}

FileUploadSection.defaultProps = {
  requestParamsConstants: [],
  onFinish: () => {},
}

FileUploadSection.contextType = FormNavigationContext
